import api from "../api";

export const getTransactions = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/transactions", { params });
};

export const getTransaction = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/transactions/${id}`);
};

export const getTransactionStats = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/transactions/stats", { params });
};

export const processRefund = async (id, reason, amount) => {
  return api.getApi().post(api.getBaseUrl() + `admin/transactions/${id}/refund`, {
    reason,
    amount
  });
};

export const getUserTransactions = async (userId, params = {}) => {
  return api.getApi().get(api.getBaseUrl() + `admin/users/${userId}/transactions`, { params });
};

